import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import selectn from "selectn";

import Icon from "../Icon";
import SocialIcons from "../SocialIcons";
import { loadNextStory } from "../../../actions/storiesStream";

import styles from "./StoryFooter.css";

class StoryFooter extends Component {

  onReadAnother = () => {
    const section = this.getSection();
    this.props.loadNextStory({ stream: section.slug }, this.props.story.id, this.getLoadedStoriesForStream(section.slug))
      .then(() => this.scrollToStory(this.props.story.id));
  };

  getLoadedStoriesForStream = (stream) => {
    return this.props.storiesStream.results
      .filter((story) => (selectn("primary_section.slug", story) === stream) ||
        story.sections.map((section) => section.slug).includes(stream))
      .map((story) => story.id);
  };

  scrollToStory = (id) => {
    try {
      const element = document.getElementById(id);
      if (element) {
        const nextArticle = element.closest("[role='article']").nextSibling;
        const isAdvert = nextArticle.children[0].classList.contains("advert-card");
        if (isAdvert) {
          const bounds = nextArticle.getBoundingClientRect();
          window.scrollBy(0, bounds.height + 100);
        }
      }
    } catch(e) {
      // Ignore error
    }
  };

  getSection = () => {
    return this.props.story.primary_section || selectn("sections[0]", this.props.story);
  };

  render() {
    const story = this.props.story;
    if (!story) return null;
    const section = this.getSection();

    return (
      <div className={classNames(styles.root, !section ? styles.center : {})}>
        {
          section &&
          <div className={classNames(styles.section, "gtm-read-another")} onClick={this.onReadAnother}>
            <Icon
              name="plus-box"
              description="Plus box"
              path="img"
              className={styles.icon}/>
            <div role="link" aria-label={`Read another ${section.name} story`} className={styles.primary}>{section.name}</div>
          </div>
        }
        {story.permalink && (
          <SocialIcons
            permalink={story.permalink}
            headline={story.headline}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    storiesStream: state.storiesStream,
  };
};

export default connect(mapStateToProps, { loadNextStory })(StoryFooter);
